export default class ServiceCommissionRateUpdateItem {
  constructor() {
    this.ServiceId = null;
    this.OverrideCommissionRateId = null;
    this.UpdateCommissionRateAutomatically = null;
  }
}
